import Nanobus from "nanobus";
var ScreenOption = /** @class */ (function () {
    function ScreenOption(element) {
        this.element = element;
        this.state = false;
        this.events = new Nanobus();
        this.init();
    }
    ScreenOption.prototype.init = function () {
        var _this = this;
        this.determinScreenOptionState();
        this.element.addEventListener('click', function () {
            _this.determinScreenOptionState();
            _this.persist();
        });
    };
    ScreenOption.prototype.isEnabled = function () {
        return this.element.checked;
    };
    ScreenOption.prototype.determinScreenOptionState = function () {
        this.isEnabled()
            ? this.enable()
            : this.disable();
    };
    ScreenOption.prototype.enable = function () {
        this.state = true;
        this.events.emit('changeState', true);
    };
    ScreenOption.prototype.disable = function () {
        this.state = false;
        this.events.emit('changeState', false);
    };
    ScreenOption.prototype.persist = function () {
        jQuery.post(ajaxurl, {
            action: 'acp_new_inline_show_button',
            value: this.state,
            layout: AC.layout,
            list_screen: AC.list_screen,
            _ajax_nonce: AC.ajax_nonce
        });
    };
    return ScreenOption;
}());
export default ScreenOption;
